import React, { useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context';

import {
    api,
    useAppSelector
} from '../internal';
import { PermissionMapC } from '@unikey/unikey-commons/release/comm';

interface IProps {

}

const AuthExpiryContainer: React.FC<IProps> = (props) => {

  const auth = useAuth();

  const [expiresAt, setExpiresAt] = useState<string>('pending');
  const [refreshCount, setRefreshCount] = useState<number>(0);
  useEffect(() => {
    if (auth.user?.expires_at) {
      setExpiresAt(new Date(auth.user?.expires_at*1000)?.toLocaleString());
      setRefreshCount(refreshCount+1);
    }
  }, [auth.user?.expires_at])

  const $activeDealerId: string = useAppSelector(state => state.portal.activeDealer?.id);
  const $userPermissions: PermissionMapC = useAppSelector(state => state.authenticatedUser.currentUser?.permissions);

  const cachedRedirect = api.cacheImpl.get('continueTo');
  return (
      <>
        <div className="auth-expiry-countdown-container">
          {/* activeSite: {$activeSiteId} | {$oidcUpdater} | Current Token Expires: {$currentExpiry} */}
          dealerId: {$activeDealerId?.slice(0,5)} | {$userPermissions?.availablePermissionsMap?.size ?? '?'}ps | {refreshCount}rfsh | Current Token Expires: {expiresAt}
          <br />
          cachedRedirect: {cachedRedirect?.slice(0, 50)}
        </div>
      </>
  )
}



export default AuthExpiryContainer;
